/* ROME THEME (Entwurf B) – interactions */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }

  /* ---- Mobile menu ---- */
  var drawer = $('[data-drawer]');
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.add('is-open'); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.remove('is-open'); }); });

  /* ---- Swipe dots on product cards and mobile gallery ---- */
  function bindDots(track, dots) {
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }, { passive: true });
  }
  $$('.card--slides').forEach(function (c) { bindDots($('.card__track', c), $$('.card__dots i', c)); });
  var gMain = $('[data-gallery]');
  if (gMain) bindDots(gMain, $$('[data-gallery-dots] i'));

  /* ---- Lightbox ---- */
  var lb = $('[data-lightbox]');
  if (lb && lb.showModal) {
    $$('[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (window.matchMedia('(max-width:900px)').matches) return;
        $('img', lb).src = b.getAttribute('data-zoom');
        lb.showModal();
      });
    });
    lb.addEventListener('click', function () { lb.close(); });
  }

  /* ---- Product form ---- */
  var form = $('[data-product-form]');
  if (!form) return;
  var jsonEl = $('[data-variants]', form);
  var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
  var idInput = $('[data-variant-id]', form);
  var btn = $('[data-atc]', form);
  var priceEl = $('[data-price]');
  var stickyPrice = $('[data-sticky-price]');
  var sizeMsg = $('[data-size-msg]', form);
  var groups = $$('[data-choices]', form).sort(function (a, b) { return (+a.getAttribute('data-opt-index') || 0) - (+b.getAttribute('data-opt-index') || 0); });
  var money = form.getAttribute('data-money') || '{{amount}}';
  var labels = { add: btn ? btn.getAttribute('data-add') : 'Add to cart', size: btn ? btn.getAttribute('data-choose') : 'Choose your size', sold: btn ? btn.getAttribute('data-sold') : 'Sold out' };

  function fmt(cents) {
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    return money
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function current() {
    return groups.map(function (g) {
      var s = $('.is-selected', g);
      return s ? s.getAttribute('data-value') : null;
    });
  }

  function match(sel) {
    if (sel.indexOf(null) > -1) return null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } }
      if (ok) return variants[i];
    }
    return null;
  }

  function markAvailability() {
    var sel = current();
    groups.forEach(function (g, gi) {
      $$('[data-value]', g).forEach(function (b) {
        var test = sel.slice(); test[gi] = b.getAttribute('data-value');
        var possible = variants.some(function (v) {
          if (!v.available) return false;
          for (var oi = 0; oi < test.length; oi++) { if (test[oi] !== null && v.options[oi] !== test[oi]) return false; }
          return true;
        });
        b.classList.toggle('is-unavailable', !possible);
      });
    });
  }

  function update() {
    var v = match(current());
    var needSize = groups.some(function (g) { return g.getAttribute('data-kind') === 'size' && !$('.is-selected', g); });
    if (v) {
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price) + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (v.featured_media && gMain) {
        var target = $('[data-media-id="' + v.featured_media.id + '"]', gMain);
        if (target) {
          if (window.matchMedia('(max-width:900px)').matches) gMain.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          else if (target !== gMain.firstElementChild) gMain.insertBefore(target, gMain.firstElementChild);
        }
      }
    } else {
      idInput.value = '';
    }
    if (!btn) return;
    if (needSize) { btn.setAttribute('data-state', 'need-size'); btn.textContent = labels.size; btn.disabled = false; }
    else if (v && v.available) { btn.setAttribute('data-state', 'ready'); btn.textContent = labels.add + ' · ' + fmt(v.price); btn.disabled = false; }
    else { btn.setAttribute('data-state', 'sold'); btn.textContent = labels.sold; btn.disabled = true; }
    var sb = $('[data-sticky-btn]');
    if (sb) sb.textContent = needSize ? labels.size : labels.add;
    markAvailability();
  }

  groups.forEach(function (g) {
    var kind = g.getAttribute('data-kind');
    $$('[data-value]', g).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-value]', g).forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-selected'); b.setAttribute('aria-checked', 'true');
        if (kind === 'size') { store('rome_size', b.getAttribute('data-value')); if (sizeMsg) sizeMsg.hidden = true; markMySize(); }
        if (kind === 'color') { var n = $('[data-color-name]', form); if (n) n.textContent = b.getAttribute('data-label'); }
        update();
      });
    });
    /* remembered size – never a default size */
    if (kind === 'size') {
      var mem = store('rome_size');
      if (mem) { var hit = $('[data-value="' + mem.replace(/"/g, '\\"') + '"]', g); if (hit) { hit.classList.add('is-selected'); hit.setAttribute('aria-checked', 'true'); } }
    }
  });

  form.addEventListener('submit', function (e) {
    if (!idInput.value) {
      e.preventDefault();
      if (sizeMsg) sizeMsg.hidden = false;
      var g = $('[data-kind="size"]', form);
      if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---- Size chart ---- */
  var dlg = $('[data-size-dialog]');
  function markMySize() {
    if (!dlg) return;
    var mem = store('rome_size');
    $$('tr[data-size]', dlg).forEach(function (r) { r.classList.toggle('is-mine', r.getAttribute('data-size') === mem); });
  }
  $$('[data-size-open]').forEach(function (b) { b.addEventListener('click', function () { if (dlg && dlg.showModal) { markMySize(); dlg.showModal(); } }); });
  $$('[data-size-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });

  /* ---- Delivery estimate (business days, no weekends) ---- */
  var del = $('[data-delivery]');
  if (del) {
    var minD = parseInt(del.getAttribute('data-min'), 10) || 3;
    var maxD = parseInt(del.getAttribute('data-max'), 10) || 6;
    var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; };
    var loc = document.documentElement.lang || 'en';
    var f = function (d) { return d.toLocaleDateString(loc, { weekday: 'short', month: 'short', day: 'numeric' }); };
    var now = new Date();
    $('[data-delivery-from]', del).textContent = f(addBiz(now, minD));
    $('[data-delivery-to]', del).textContent = f(addBiz(now, maxD));
    del.hidden = false;
  }

  /* ---- Sticky add to cart (mobile) ---- */
  var sticky = $('[data-sticky]');
  if (sticky && btn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
    $('[data-sticky-btn]', sticky).addEventListener('click', function () {
      if (idInput.value) form.requestSubmit ? form.requestSubmit() : form.submit();
      else { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (sizeMsg) sizeMsg.hidden = false; }
    });
  }

  update();
})();
